import { defineComponent, useTemplateRef, ref, onMounted, nextTick, onUnmounted, openBlock, createElementBlock, Fragment, createVNode, unref, withCtx, normalizeClass, createElementVNode, toDisplayString, createTextVNode, createCommentVNode, h } from 'vue';
import { EditorService } from '@ssml-editor/core';
import { h as createEditor } from '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { ParagraphModule } from '../editor/module/paragraph/module.js';
import { l as lodashExports } from '../_virtual/lodash.js';
import { withEvent } from '../extension/event/with-event.js';
import { withExt } from '../extension/ext/with-ext.js';
import { withHtml } from '../extension/html/with-html.js';
import { withMaxLength } from '../extension/max-length/with-max-length.js';
import { withSerialization } from '../extension/serialize/with-serialize.js';
import { withText } from '../extension/text/with-text.js';
import { h as Slate, E as Editable } from '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/use-focused-C_oKuppP.js';
import '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/hotkeys-BEBL6MB3.js';
import { withDOM } from '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/dom.js';
import { withHistory } from '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/history.js';

const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "editor-text-area",
  props: {
    config: {}
  },
  emits: ["created", "change", "selectionChange", "valueChange", "destroyed", "focus", "blur", "maxLength"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit = __emit;
    const editorTextAreaRef = useTemplateRef("editor-text-area");
    const editorLength = ref(0);
    const editorLeftLength = ref(Infinity);
    const editorStyle = {
      ...__props.config.style,
      maxHeight: __props.config.style?.maxHeight && __props.config.scroll !== false ? __props.config.style.maxHeight : void 0,
      height: __props.config.style?.height && __props.config.scroll !== false ? __props.config.style.height : "auto"
    };
    const editorService = new EditorService(__props.config.databaseName, __props.config.html);
    const htmlSerializers = __props.config.modules?.filter((module) => {
      return typeof module.elementToHtml !== "undefined";
    }).map((module) => {
      return {
        type: module.type,
        serializer: module.elementToHtml
      };
    }) || [];
    const htmlDeserializers = __props.config.modules?.filter((module) => {
      return typeof module.htmlToElement !== "undefined";
    }).map((module) => {
      return {
        type: module.type,
        deserializer: module.htmlToElement
      };
    }) || [];
    const plugins = [
      ...__props.config.plugins || [],
      ...__props.config.modules?.filter((module) => {
        return typeof module.plugin !== "undefined";
      }).map((module) => {
        return module.plugin;
      }) || []
    ];
    const serializers = __props.config.modules?.filter((module) => {
      return typeof module.serializer !== "undefined";
    }).map((module) => {
      return {
        type: module.type,
        serializer: module.serializer
      };
    }) || [];
    const normalizers = __props.config.normalizers || [];
    const applyPlugins = (editor2, plugins2) => {
      plugins2.forEach((plugin) => {
        editor2 = plugin(editor2);
      });
      return editor2;
    };
    const editor = applyPlugins(
      withMaxLength(
        withHtml(
          withSerialization(
            withText(withExt(withEvent(withHistory(withDOM(createEditor()))))),
            serializers,
            normalizers
          ),
          htmlSerializers,
          htmlDeserializers
        ),
        __props.config.maxLength
      ),
      plugins
    );
    const renderElement = (props) => {
      const editorModules = __props.config.modules || [];
      const type = props.element.type;
      for (const module of editorModules) {
        if (module.renderElement && module.type === type) {
          return module.renderElement({ ...props, editor });
        }
      }
      return ParagraphModule.renderElement({ ...props, editor });
    };
    const renderLeaf = (props) => {
      if (__props.config.renderLeaf) {
        return __props.config.renderLeaf(props);
      } else {
        return h("span", props.attributes, props.children);
      }
    };
    const renderText = (props) => {
      if (__props.config.renderText) {
        return __props.config.renderText(props);
      } else {
        return h("span", props.attributes, props.children);
      }
    };
    const renderChunk = (props) => {
      if (__props.config.renderChunk) {
        return __props.config.renderChunk(props);
      } else {
        return h("div", props.attributes, props.children);
      }
    };
    const renderPlaceholder = (props) => {
      if (__props.config.renderPlaceholder) {
        return __props.config.renderPlaceholder(props);
      }
      const attributes = props.attributes;
      const style = attributes.style;
      if (style) {
        attributes.style = Object.assign({}, style, {
          whiteSpace: "nowrap",
          left: "0"
        });
      }
      return h("span", attributes, props.children);
    };
    const getHtml = () => {
      return editor.html;
    };
    const saveHtmlHandler = async () => {
      return await editorService.saveHtml(getHtml());
    };
    const throttleSaveHtml = lodashExports.throttle(
      saveHtmlHandler,
      __props.config.html?.autoSaveWait || 0,
      {
        leading: false,
        trailing: true
      }
    );
    const calculateEditorLength = () => {
      editorLength.value = editor.getLength();
      if (__props.config.maxLength && __props.config.maxLength > 0) {
        editorLeftLength.value = editor.getLeftLength();
        if (editorLeftLength.value <= 0) {
          emit("maxLength", editor, editor.htmlElement);
        }
      }
    };
    const changeHandler = (options) => {
      editor.emit("change", editor, editorTextAreaRef.value?.$el || null, options);
      emit("change", editor, editorTextAreaRef.value?.$el || null, options);
    };
    const selectionChangeHandler = (options) => {
      editor.emit(
        "selectionChange",
        editor,
        editorTextAreaRef.value?.$el || null,
        options
      );
      emit(
        "selectionChange",
        editor,
        editorTextAreaRef.value?.$el || null,
        options
      );
    };
    const valueChangeHandler = (options) => {
      if (__props.config.html?.autoSave === true) {
        throttleSaveHtml();
      }
      editor.emit(
        "valueChange",
        editor,
        editorTextAreaRef.value?.$el || null,
        options
      );
      emit("valueChange", editor, editorTextAreaRef.value?.$el || null, options);
      calculateEditorLength();
    };
    const focusHandler = () => {
      editor.emit("focus", editor, editorTextAreaRef.value?.$el || null);
      emit("focus", editor, editorTextAreaRef.value?.$el || null);
    };
    const blurHandler = () => {
      editor.emit("blur", editor, editorTextAreaRef.value?.$el || null);
      emit("blur", editor, editorTextAreaRef.value?.$el || null);
    };
    const editorOnMouseoverHandler = (event) => {
      const target = event.target;
      const currentTarget = event.currentTarget;
      if (currentTarget && target && target.classList.contains("se-mark")) {
        currentTarget.querySelectorAll(".hovered").forEach((element) => {
          element.classList.remove("hovered");
        });
        let slateNodeElement = target.parentElement;
        while (slateNodeElement && slateNodeElement.dataset.slateNode !== "element") {
          slateNodeElement = slateNodeElement.parentElement;
        }
        slateNodeElement?.classList.add("hovered");
      }
      event.stopPropagation();
    };
    const readHtml = async () => {
      return await editorService.readHtml();
    };
    __expose({
      editor
    });
    onMounted(async () => {
      const html = await readHtml();
      editor.setHtml(html);
      const element = editorTextAreaRef.value?.$el || null;
      editor.htmlElement = element;
      nextTick(() => {
        editor.emit("created", editor, element);
        emit("created", editor, element);
        calculateEditorLength();
      });
    });
    onUnmounted(() => {
      editor.htmlElement = null;
      editor.emit("destroyed", editor, editorTextAreaRef.value?.$el || null);
      emit("destroyed", editor, editorTextAreaRef.value?.$el || null);
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [
        createVNode(unref(Slate), {
          editor: unref(editor),
          decorate: __props.config.decorate,
          "render-element": renderElement,
          "render-leaf": renderLeaf,
          "render-placeholder": renderPlaceholder,
          "render-text": __props.config.renderText ? renderText : void 0,
          "render-chunk": __props.config.renderChunk ? renderChunk : void 0,
          onChange: changeHandler,
          onSelectionchange: selectionChangeHandler,
          onValuechange: valueChangeHandler
        }, {
          default: withCtx(() => [
            createVNode(unref(Editable), {
              ref: "editor-text-area",
              class: normalizeClass(["se-editor-text-area", {
                "allow-zoom": __props.config?.animation?.zoom,
                "allow-grayscale": __props.config?.animation?.grayscale
              }]),
              "read-only": __props.config.readOnly,
              placeholder: __props.config.placeholder,
              "auto-focus": __props.config.autoFocus,
              style: editorStyle,
              onFocus: focusHandler,
              onBlur: blurHandler,
              onMouseover: editorOnMouseoverHandler
            }, null, 8, ["read-only", "placeholder", "auto-focus", "class"])
          ]),
          _: 1
        }, 8, ["editor", "decorate", "render-text", "render-chunk"]),
        createElementVNode("span", { class: "se-count" }, [
          createElementVNode("i", {
            class: normalizeClass({ "se-weight": editorLeftLength.value <= 0 })
          }, toDisplayString(editorLength.value), 3),
          __props.config.maxLength && __props.config.maxLength > 0 ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
            createTextVNode("/"),
            createElementVNode("i", null, toDisplayString(__props.config.maxLength), 1)
          ], 64)) : createCommentVNode("", true)
        ])
      ], 64);
    };
  }
});

export { _sfc_main as default };
//# sourceMappingURL=editor-text-area.vue.js.map
